import { assetUrl } from '@/lib/assetUrl';

function wait(ms: number): Promise<void> {
  return new Promise((r) => setTimeout(r, ms));
}

declare global {
  interface Window {
    marked?: {
      setOptions: (opts: Record<string, unknown>) => void;
      parse: (content: string) => string;
    };
  }
}

let markedReady: Promise<void> | null = null;

export async function ensureMarkedReady(): Promise<void> {
  if (window.marked?.parse) return;

  if (!markedReady) {
    markedReady = (async () => {
      const src = assetUrl('/assets/js/marked.min.js');
      const base = src.split('?')[0];
      const existing = document.querySelector(`script[src^="${base}"]`);

      if (!existing) {
        await new Promise<void>((resolve, reject) => {
          const script = document.createElement('script');
          script.src = src;
          script.onload = () => resolve();
          script.onerror = () => reject(new Error('marked-script'));
          document.body.appendChild(script);
        });
      }

      for (let i = 0; i < 40; i++) {
        if (window.marked?.parse) {
          window.marked.setOptions({ breaks: true, gfm: true });
          return;
        }
        await wait(50);
      }

      throw new Error('marked-not-available');
    })();
  }

  await markedReady;
}

export function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

export function parseChatMarkdown(content: string): string {
  if (window.marked?.parse) {
    try {
      return window.marked.parse(content);
    } catch {
      return escapeHtml(content);
    }
  }
  return escapeHtml(content);
}
